"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.HighlightedContent = exports.getUnhighlightedText = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var ui_common_1 = require("@codametrix/ui-common");
var ui_common_2 = require("@codametrix/ui-common");
var counterGenerator = function (id) {
    var idx = 0;
    return function () { return "{id}-".concat(idx++); };
};
/**
 * Returns a portion of text designed to be displayed without highlighting.
 * If no text was selected, the return's advanced property will be 0.
 * @param span
 * @param segment
 * @param currentIndex
 */
var getUnhighlightedText = function (span, segment, currentIndex, counter) {
    var firstSpanStarts = span.span.start;
    var sliceLength = firstSpanStarts - segment.start - currentIndex;
    if (sliceLength) {
        var slice = segment.text.slice(currentIndex, currentIndex + sliceLength);
        return {
            segment: unhighlightedText(slice, counter),
            advanced: sliceLength
        };
    }
    return { advanced: 0 };
};
exports.getUnhighlightedText = getUnhighlightedText;
// ---------------------------------------
// React based code
// ---------------------------------------
var unhighlightedText = function (text, counter) {
    if (ui_common_1.objectUtils.isString(text) && text.trim().length === 0) {
        return emptySegment({ key: "span-".concat(counter()) });
    }
    return ((0, jsx_runtime_1.jsx)("span", __assign({ className: "unhighlighted qa-unhighlighted" }, { children: text }), "span-".concat(counter())));
};
var highlightText = function (text, span, counter) {
    var _a, _b;
    var hasContent = ui_common_1.objectUtils.isString(text) && text.trim().length > 0;
    var content = ui_common_1.objectUtils.isString(text) && !hasContent ? (0, jsx_runtime_1.jsx)("br", {}) : text;
    //@ts-ignore
    var provenance = ((_b = (_a = span.code) === null || _a === void 0 ? void 0 : _a.provenance) !== null && _b !== void 0 ? _b : '').toLowerCase();
    var classNames = [
        { 'highlighted-segment': hasContent, 'empty-block': !hasContent },
        "qa-highlighted",
        "highlighted-".concat(span.codeType.toLowerCase()),
        "highlighted-".concat(provenance),
        span.span.uuid ? "span-".concat(span.span.uuid) : false,
        // hashes are not currently
        span.span.hash ? "span-".concat(span.span.hash) : false,
        { 'highlighted-active': span.active, 'qa-highlighted-active': span.active }
    ];
    return ((0, jsx_runtime_1.jsx)("span", __assign({ id: span.span.uuid, className: (0, classnames_1["default"])(classNames) }, { children: content }), "span-".concat(counter())));
};
/**
 * Given a segment, apply all the evidence to it.
 * @param segment
 * @param spans
 */
var highlightSegment = function (segment, spans, counter) {
    var segments = [];
    var currentIndex = 0;
    var seen = new Set();
    spans.forEach(function (span, idx) {
        if (!seen.has(span)) {
            // if the span starts later than the segment, let's peel off first chunk of text
            var unhighlighted = (0, exports.getUnhighlightedText)(span, segment, currentIndex, counter);
            if (unhighlighted.segment) {
                segments.push(unhighlighted.segment);
                // advance along the string length n units
                currentIndex += unhighlighted.advanced;
            }
            // determine if there's any nesting.
            var subsections = spans.slice(idx);
            var nest = ui_common_2.highlighterUtils.buildNest(subsections, segment);
            var text = segment.text.slice(nest.start, nest.end);
            // Note: spans operate on a relative basis.
            // span.start = 53 may mean that the span is only
            // starting 3 characters in if the span starts at character
            // 50; as would be the case with a segment that starts at 50.
            // text slicing on the other hand, operates on absolute basis.
            if (!nest.hasChildren) {
                segments.push(highlightText(text, span, counter));
            }
            else {
                // 1. create psuedo segment
                var start = segment.start + currentIndex;
                var end = start + text.length;
                var psuedoSegment = {
                    text: text,
                    start: start,
                    end: end
                };
                // 2. recurse through data structure
                var highlightedSubsegments = highlightSegment(psuedoSegment, nest.children, counter);
                nest.children.forEach(function (child) {
                    seen.add(child);
                });
                // 3. wrap the output in another span
                segments.push(highlightText(highlightedSubsegments, nest.parent, counter));
            }
            currentIndex += text.length;
        }
    });
    // if there are any leftovers, append the raw string.s
    var leftoverText = segment.text.slice(currentIndex);
    if (leftoverText.length) {
        segments.push(unhighlightedText(leftoverText, counter));
    }
    if (!segments.length) {
        var emptyKey = counter();
        segments.push(emptySegment({ className: "span-no-segments-".concat(emptyKey), key: emptyKey }));
    }
    return segments;
};
var emptySegment = function (props) {
    var classes = [props.className, 'empty-segment'];
    return ((0, jsx_runtime_1.jsx)("div", __assign({}, props, { className: (0, classnames_1["default"])(classes) }, { children: (0, jsx_runtime_1.jsx)("br", {}) })));
};
var highlightSegments = function (segments, spans, counter) {
    var tempSpans = __spreadArray([], __read(spans), false);
    var texts = [];
    var currentSegment = 0;
    var totalSegments = segments.length;
    while (currentSegment < totalSegments) {
        var activeSegment = segments[currentSegment];
        var activeSpans = ui_common_2.highlighterUtils.getActiveSpans(tempSpans, activeSegment);
        var textContents = highlightSegment(activeSegment, activeSpans, counter);
        texts.push((0, jsx_runtime_1.jsxs)("div", __assign({ className: "content-segment" }, { children: [(0, jsx_runtime_1.jsxs)("span", __assign({ className: "highlighter-diagnostics" }, { children: [activeSegment.start, " - ", activeSegment.end] })), textContents] }), "content-segment-".concat(counter())));
        currentSegment++;
    }
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: "highlighted-content" }, { children: texts }));
};
var HighlightedContent = function (props) {
    var spans = props.spans, segments = props.segments, id = props.id;
    var counter = counterGenerator(id);
    var texts = highlightSegments(segments, spans, counter);
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: "highlighted-content" }, { children: texts }));
};
exports.HighlightedContent = HighlightedContent;
//# sourceMappingURL=highlighted-content.js.map